/**
 * Compile-time feature flags. Kept in their own module (not constants.ts) so
 * a test file can `vi.mock('@/lib/features', …)` one flag without touching
 * gameplay constants.
 */

/**
 * Sound UI (header MuteToggle + Settings "Hang" row) and Howl preloading.
 * OFF until real audio assets replace the silent 177-byte .ogg stubs in
 * public/audio/ — a sound toggle that plays nothing reads as broken.
 * The audio module and every audio().play() call site stay wired; with
 * init() skipped, play() is a no-op.
 */
export const SOUND_UI_ENABLED = false;
